import { bl_inv_pdg_unique_location_combination_line_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryPdgUniqueLocationCombinationLineContainerModel extends BaseContainerModel {
  bl_inv_pdg_unique_location_combination_line: bl_inv_pdg_unique_location_combination_line_RowClass = new bl_inv_pdg_unique_location_combination_line_RowClass();
}
